import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  FormControl,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { AvatarImage } from '~/shared/components/AvatarImage';

export const StyledDialogPaper = styled(Paper)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    margin: 0,
    maxWidth: '100%',
    width: '100%',
    maxHeight: '100vh',
    height: '100vh',
    borderRadius: 0,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
}));

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  maxHeight: '70vh',
  overflowY: 'auto',
  [theme.breakpoints.down('sm')]: {
    flex: '1 1 0',
    minHeight: 0,
    maxHeight: 'none',
    overflowY: 'auto',
  },
  [theme.breakpoints.up('sm')]: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
}));

export const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  flexShrink: 0,
  [theme.breakpoints.down('sm')]: {
    borderTop: '1px solid',
    borderColor: theme.palette.divider,
    backgroundColor: theme.palette.background.paper,
  },
  [theme.breakpoints.up('sm')]: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
}));

export const StyledSubmitButton = styled(Button)(({ theme }) => ({
  minHeight: 44,
  paddingTop: theme.spacing(1.25),
  paddingBottom: theme.spacing(1.25),
  paddingLeft: theme.spacing(2.5),
  paddingRight: theme.spacing(2.5),
  backgroundColor: theme.palette.darkNavy,
  color: theme.palette.common.white,
  '&:hover': {
    backgroundColor: theme.palette.amount.main,
  },
}));

export const ReceiptBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  border: '1px solid',
  borderColor: theme.palette.divider,
  borderRadius: theme.shape.borderRadius,
  fontSize: theme.typography.caption.fontSize,
}));

export const RetainerExpertCard = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  border: '1px solid',
  borderColor: theme.palette.divider,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
}));

export const RetainerExpertCardAvatar = styled(AvatarImage)(({ theme }) => ({
  width: 48,
  height: 48,
  flexShrink: 0,
  fontSize: theme.typography.body1.fontSize,
}));

export const RetainerExpertCardContent = styled(Stack)(({ theme }) => ({
  flex: 1,
  minWidth: 0,
  gap: theme.spacing(0.25),
}));

export const ReceiptRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'baseline',
  gap: theme.spacing(2),
  paddingTop: theme.spacing(0.75),
  paddingBottom: theme.spacing(0.75),
  '&:not(:last-child)': {
    borderBottom: '1px dashed',
    borderColor: theme.palette.divider,
  },
}));

export const ReceiptLabel = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.body2.fontSize,
  color: theme.palette.text.secondary,
  flexShrink: 0,
  margin: 0,
}));

export const ReceiptValue = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.body2.fontSize,
  color: theme.palette.text.secondary,
  fontFamily: 'monospace',
  textAlign: 'right',
  wordBreak: 'break-word',
  margin: 0,
}));

export const BillingLabel = styled(Typography)(({ theme }) => ({
  display: 'block',
  fontWeight: 600,
  marginBottom: theme.spacing(1),
}));

export const FeeTypeFormControl = styled(FormControl)(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));

export const FormStack = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(2.5),
}));

export const FormWrapper = styled('form')(({ theme }) => ({
  marginTop: theme.spacing(2),
}));
